import useSWRImmutable from 'swr/immutable'

import { useApis } from '../contexts/api-context'

export type TherapistCategoryType = {
  id: number
  name: string
  description?: string
  isNonMedicalTreatment?: boolean
}

const useTherapistCategories = () => {
  const { api } = useApis()

  const { data } = useSWRImmutable<TherapistCategoryType[]>('useTherapistCategories', async () => {
    const res = await api.getTherapistCategories()
    return res.data
  })

  return { categories: data }
}

export default useTherapistCategories
